import { Component, OnInit } from '@angular/core';
import { Route } from '@angular/compiler/src/core';
import { Router, ActivatedRoute } from '@angular/router';

import 'parse';
const parse: typeof Parse = require('parse');

@Component({
  selector: 'app-redirect-device-local-ip',
  templateUrl: './redirect-device-local-ip.component.html',
  styleUrls: ['./redirect-device-local-ip.component.less']
})
export class RedirectDeviceLocalIpComponent implements OnInit {

  constructor(
    private readonly _route : ActivatedRoute,
    private readonly _router : Router,
  ) { }

  ngOnInit() {
    let url = this._route.snapshot.url;
    if (url){
      if (url[1] && url[1].path)
      {
        parse.Cloud.run('getIPMachine', {
          id : url[1].path,
        }).then(
          function (result) {
            if (result && result.length > 8){
              window.location.replace("http://"+result+":4200")
            } else
              this._router.navigate([''])
          },
          function (error) {
            this._router.navigate([''])
          }
        )
      }else {
        this._router.navigate([''])
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/element/redirect-device-local-ip/redirect-device-local-ip.component.ts